import { cloneDeep, get } from "lodash-es";
import React, { FC, ReactElement } from "react";

import { NativeSelect, OutlinedInput } from "@mui/material";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";

import criteriaJson from "../../../../json/ppl_criteria.json";
import { PplRule } from "../../../../store/pomeriumApi";

interface OperatorSelectProps {
  readonly: boolean;
  pplArr: any[];
  savePPL(ppl: PplRule[]): void;
  condition: "and" | "or" | "not" | "nor";
  blockIDX: number;
  allowDeny: "allow" | "deny";
  ruleIDX: number;
  criteria: string;
  operator: string;
}

const getNewOperatorValue = (
  criterion: string,
  operator: string,
  originalValue: any,
): any => {
  switch (criterion) {
    case "device":
      switch (operator) {
        case "type":
          return "any";
        case "approved":
          return true;
        default:
          return "";
      }
    case "client_certificate":
      switch (operator) {
        case "san_dns":
        case "san_email":
        case "san_uri":
          return { is: "" };
        default:
          return [""];
      }
    default:
      return originalValue;
  }
};

const OperatorSelect: FC<React.PropsWithChildren<OperatorSelectProps>> = ({
  readonly,
  pplArr,
  savePPL,
  condition,
  blockIDX,
  allowDeny,
  ruleIDX,
  criteria,
  operator,
}: OperatorSelectProps): ReactElement => {
  const operators = get(criteriaJson, criteria.split("/")[0] + ".operators");
  return (
    <FormControl variant="outlined" sx={{ width: `95%` }} margin="dense">
      <InputLabel htmlFor="outlined-operator-native-simple">
        Operator
      </InputLabel>
      <NativeSelect
        value={operator}
        disabled={!operators?.length || readonly}
        size="small"
        onChange={(evt) => {
          const arr = cloneDeep(pplArr);
          if (operators?.length) {
            const value = evt.target.value.toString();
            const originalValue =
              arr[blockIDX][allowDeny][condition][ruleIDX][criteria][operator];
            delete arr[blockIDX][allowDeny][condition][ruleIDX][criteria][
              operator
            ];
            arr[blockIDX][allowDeny][condition][ruleIDX][criteria][value] =
              getNewOperatorValue(criteria, value, originalValue);
          }
          savePPL(arr);
        }}
        input={<OutlinedInput label="Operator" />}
        inputProps={{
          name: "Operator",
          id:
            "outlined-operator-native-simple" +
            blockIDX +
            allowDeny +
            condition +
            ruleIDX +
            operator,
        }}
      >
        {!operators?.length && (
          <option
            key={
              blockIDX +
              allowDeny +
              condition +
              ruleIDX +
              criteria +
              "operator" +
              "is"
            }
            value={"is"}
          >
            Is
          </option>
        )}
        {operators.map((operator: string) => {
          return (
            <option
              key={
                blockIDX +
                allowDeny +
                condition +
                ruleIDX +
                criteria +
                "operator" +
                operator
              }
              value={operator}
            >
              {operator
                .replace(/_/g, " ")
                .replace(/(?: |\b)(\w)/g, function (op) {
                  return op.toUpperCase();
                })}
            </option>
          );
        })}
      </NativeSelect>
    </FormControl>
  );
};

export default OperatorSelect;
